<template>
	<modal
		:title="title"
		:active="active"
		:dismissable="true"
		@dismiss="dismiss"
	>

		<modal-body>
			<p v-if="isGroupAdmin">
				{{user.firstName}} will no longer be able to manage or view {{group.reportName}}'s dashboards, users or group settings.
			</p>
            <p v-else>
                {{user.firstName}} will no longer be able to access {{group.reportName}}'s dashboards.
            </p>
		</modal-body>

		<modal-actions>
			<btn primary @click="onRemove">Remove</btn>
			<btn link @click="cancel">Cancel</btn>
		</modal-actions>
		
	</modal>
</template>


<script>
    import { ModalMixin } from 'pdk/mixins';
	

	export default {
		name: 'remove-group-user-modal',
		mixins: [ModalMixin],
		props: {
            user: {
                type: Object,
                required: true
            },
            group: {
                type: Object,
                required: true
            }
		},
        computed: {
            isGroupAdmin() {
                if (!this.group) return false;
                return this.group.role == 2; // Group Admin
            },
			title() {
				return `Remove ${this.user.firstName} ${this.user.lastName} from "${this.group.reportName}"?`;
			}
		},
		methods: {
			onRemove() {
                this.$emit('remove', this.group);
                this.close();
			}
		}
	};
</script>
